import styled from "styled-components";

export const Item = styled.div`
  margin-top: 56px;
  margin-bottom: 40px;
`;
